import angular from 'angular';
import _ from 'lodash';

export default angular.module('manage-inventory-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      manageInventory: {
        PATTERN_DOES_NOT_MATCH: () => ({ title: gettextCatalog.getString('Number must match <productId>_<packId>_<portionId> pattern') }),
        ENTITY_NOT_FOUND: () => ({ title: gettextCatalog.getString('Entity or Sub-Entity not found.') }),
      },
      manageInventoryResultCodes: {
        1: gettextCatalog.getString('Transaction is not available for this product. Please check game number.'),
        5: gettextCatalog.getString('Sorry, transaction failed. Please try again later.'),
        6: gettextCatalog.getString('Sorry, transaction failed. Please try again later.'),
        16: (params) => gettextCatalog.getString('According to our records, this is not a {{ pack }} in your inventory. Please check {{ pack }} number and try again.', { pack: params.terms.PACK.singularLowerCase }),
        18: gettextCatalog.getString('Sorry, transition requires more inventory than is currently at this location.'),
        20: gettextCatalog.getString('According to our records, this retailer location is not active. Please contact the Lottery.'),
        32: gettextCatalog.getString('The number entered does not match our records. Please try again.'),
        35: gettextCatalog.getString('There is no game in your inventory with that game number. Please check the number and try again.'),
        40: gettextCatalog.getString('This game is currently not available for sale. Please contact the Lottery or your sales representative for more information.'),
        44: gettextCatalog.getString('Transaction failed. Validations have been made to tickets in the range to be returned.'),
        45: gettextCatalog.getString('Transaction failed. Validations have been made to tickets in the range to be returned.'),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/config/errorcodes.conf.js